import React from 'react';
import styled from 'styled-components';
import { PRESET_HOURS, offAfter, windowMinutes, describeWindow } from '../config/relayWindow';

// Photoperiod presets for a timer window. A preset keeps the ON time and moves the
// OFF time so the relay is on for that many hours; it only fills the inputs — the
// caller's Save still commits it, same as typing a time.

const Line = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${props => props.theme.spacing.xs};
`;

const Chip = styled.button`
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-family: inherit;
  font-variant-numeric: tabular-nums;
  cursor: pointer;
  border: 1px solid ${props => (props.active ? props.theme.colors.primary : props.theme.colors.border)};
  background: ${props => (props.active ? props.theme.colors.primary : props.theme.colors.surface)};
  color: ${props => (props.active ? props.theme.colors.textInverse : props.theme.colors.textSecondary)};

  &:hover:not(:disabled) { border-color: ${props => props.theme.colors.primary}; }
  &:disabled { cursor: not-allowed; opacity: 0.6; }
`;

const Summary = styled.span`
  margin-left: ${props => props.theme.spacing.xs};
  font-size: 0.72rem;
  color: ${props => props.theme.colors.textSecondary};
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
`;

const HourPresets = ({ on, off, onPick, disabled = false, note }) => {
  const current = windowMinutes(on, off);
  const summary = describeWindow(on, off);

  return (
    <Line>
      {PRESET_HOURS.map((hours) => {
        const active = current?.onMinutes === hours * 60;
        return (
          <Chip
            key={hours}
            type="button"
            active={active}
            aria-pressed={active}
            disabled={disabled || !offAfter(on, hours)}
            onClick={() => onPick(offAfter(on, hours))}
          >
            {hours} h
          </Chip>
        );
      })}
      {summary && <Summary>{summary}</Summary>}
      {note && <Summary>· {note}</Summary>}
    </Line>
  );
};

export default HourPresets;
